<template>
  <header id="page-header">
    <b-navbar toggleable="md" type="inverse fixed-top">

      <b-nav-toggle target="nav_collapse">{{ $t('message.title.menu') }}</b-nav-toggle>

      <b-link class="navbar-brand">
        <h1 class="navbar-brand"><span class="foobar-logo">Foo</span><span>Bar</span><span class="foobar-logo">Beer</span></h1>
      </b-link>

      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav>
          <b-nav-item><router-link to="/">{{ $t('message.title.main.home') }}</router-link></b-nav-item>
          <b-nav-item><router-link to="/about-foobar">About</router-link></b-nav-item>
          <b-nav-item><router-link to="/privacy-and-license">Privacy &amp; License</router-link></b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto" v-show="$store.state.auth.editor">
          <b-nav-item href="#"><router-link to="/add-foobar"><icon name="plus"></icon>&nbsp;{{ $t('message.title.main.add') }}</router-link></b-nav-item>
        </b-navbar-nav>

        <b-nav is-nav-bar class="ml-auto navbar-right">
          <b-nav-item href="#"><router-link to="/foobars">{{ $t('message.title.main.foobars') }}</router-link></b-nav-item>
        </b-nav>

      </b-collapse>
    </b-navbar>
  </header>
</template>

<script>
  import Vue from 'vue'
  import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm'
  import VueScrollTo from 'vue-scrollto/vue-scrollto'
  import 'vue-awesome/icons'
  import Icon from 'vue-awesome/components/Icon.vue'

  Vue.use(BootstrapVue, VueScrollTo)

  export default {
    components: {
      BootstrapVue, VueScrollTo, Icon
    },
    methods: {
      updateLang(lang) {
        Vue.i18n.set(lang)
      }
    }
  }
</script>

<style>
  li.nav-item a {
    color: #fff;
    font-weight: bold;
  }
  li.nav-item a:hover {
    color: #000;
  }
</style>



// WEBPACK FOOTER //
// Header.vue?7ac46480